<button matMiniFab type="button" (click)="togglePanel()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <mat-icon >layers</mat-icon>

</button>
<ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="expandPanel"
        [cdkConnectedOverlayPositions]="overlayPositions || defaultOverlayPositions"
        (detach)="expandPanel = false"

>
    <div [class.resize]="resize" [class.dual-view-panel]="dualViewEnabled" class="inverse-surface overlay" >
        <div class="row row-cols-2 text-center">
            <div class="col">
                <button [class.selected]="isImageryShown" class="icon-button" (click)="showImagery()">
                    <img class="icon" src="{{ imageryIcon }}" />
                </button>
                <br />
                Imagery
            </div>
            <div class="col" matTooltip="{{ viewerService.is3DMode() ? 'Basemap not available in 3D mode.' : '' }}">
                <button
                        [class.selected]="!isImageryShown"
                        [class.disabled]="viewerService.is3DMode()"
                        class="icon-button"
                        [disabled]="viewerService.is3DMode()"
                        (click)="showBasemap()">
                    <img class="icon" src="{{ baseMapIcon }}" />
                </button>
                <br />
                Basemap
            </div>
        </div>
        <mat-divider class="divider"></mat-divider>

        <mat-slide-toggle
                (change)="toggleAutoContrast($event.checked)"
                [disabled]="!(isActivatedAutoContrast || centerAOI?.isGraySky())"
                [checked]="isActivatedAutoContrast" hideIcon="true"
                *ngIf="(flagService.getFlags$() | async)?.[FeatureFlags.ENHANCE_CONTRAST] && autoContrastAllowed">
            <mat-icon class="mirror small-icon" [matTooltip]="centerAOI?.isGraySky() ? '' : 'Select a Gray Sky collection to use this feature'">auto_fix_high</mat-icon>
            Gray Sky Contrast
        </mat-slide-toggle>

        <div *ngIf="overlayLayers?.length">
            <div cdkDropList (cdkDropListDropped)="changeOverlayOrder($event)">
                <div class="overlay-widget" *ngFor="let layer of overlayLayers" cdkDrag>
                    <div class="drag-placeholder" *cdkDragPlaceholder></div>
                    <app-overlay-layer-item
                            [layer]="layer"
                            (changeChildVisibilityEvent)="changeChildVisibility($event)"
                            (fitFeatureEvent)="zoomToFeature($event.layer, $event.feature)"
                            (fitEvent)="fitToBbox($event.bbox, $event.fitOptions)"
                            (removeLayerEvent)="removeUserLayer($event)"
                            (changeVisibilityEvent)="changeVisibility($event)"></app-overlay-layer-item>
                </div>
            </div>
        </div>
    </div>
</ng-template>